import httpService from "@src/utility/httpService";
import { config } from '@uhg-abyss/web/tools/config';
import {TOP_FILTER_EXTENDED_TIN} from "./apiUrlConstants";
import {PNB_UPLOAD_TO_IMPACT} from "@src/CommonComponents/constant/api_url_constants";
import {HEADER_DATA} from "@src/apps/ProviderBriefing/ProviderBriefingDocument/Main/constant";
import {getSafeValue} from "@src/apps/ProviderBriefing/ProviderBriefingDocument/Main/main.service";

const _httpService = new httpService();

export const uploadDocToImpact = async (payload: {
    genesisId: string;
    title: string;
    pathOnClient: string;
    versionData: string;
}) => {
    const apiDomainInternal = config('PNB_DOMAIN_INTERNAL');
    _httpService.setBaseURL(apiDomainInternal);
    const response: any = await _httpService.push(`/${PNB_UPLOAD_TO_IMPACT}`, payload);
    return response;
};
const templateData = JSON.parse(sessionStorage.getItem('PNBData') ?? '{}');
export const fetchHeaderData = async (payload?) => {
    const pid = new URL(window.location.href).searchParams.get('pid');
    const apiDomainInternal = config('API_DOMAIN_INTERNAL');
    _httpService.setBaseURL(apiDomainInternal);
    if (payload) {
        const url = `/${TOP_FILTER_EXTENDED_TIN}`;
        try {
            const response: any = await _httpService.push(url, payload);
            return response;
        } catch (error) {
            console.error('Error fetching header data:', error);
        }
    } else {
        if (templateData?.selectedTab?.key === 'TAX_ID' && !pid) {
            const extractTins = (data: { value: string; title: string }[]): string => {
                return data.map(item => item.value).join(',');
            };
            const url = `/${TOP_FILTER_EXTENDED_TIN}`;
            const payload = {
                'RequestedJourney': 'provTinListFilter',
                'ProvTinListFilter': {
                    'Tin': extractTins(templateData.options)
                }
            };
            try {
                let headerResponse = HEADER_DATA;
                const response: any = await _httpService.push(
                url, payload)
                headerResponse.headerData[0].value = getSafeValue('Data.0.RegionName', response);
                headerResponse.headerData[1].value = getSafeValue('Data.0.State', response);
                headerResponse.headerData[2].value = getSafeValue('Data.0.MajorMarketName', response);
                headerResponse.headerData[3].value = getSafeValue('Data.0.TaxIdType', response);
                headerResponse.headerData[4].value = getSafeValue('Data.0.FinancialOwner', response);
                headerResponse.headerValue = getSafeValue('Data.0.TinName', response);
                return headerResponse;
            } catch (error) {
                console.error('Error fetching header data:', error);
            }
        } else {
            return {};
        }
    }
    
}